import TagManager from "react-gtm-module";
import firebase from "services/firebase";

import { BillData, Unit } from "../services/api";

type UseGaEventsType = {
  handleClickDocument: (document: string) => void;
  handleClickCopyBarCode: (
    document: string,
    unit: Unit,
    installment: BillData
  ) => void;
  handleClickDownloadResumeBill: (
    document: string,
    unit: Unit,
    installment: BillData
  ) => void;
  handleClickDownloadCompleteBill: (
    document: string,
    unit: Unit,
    installment: BillData
  ) => void;
  handleClickFilterOpen: (document: string, unit: Unit) => void;
  handleClickFilterClosed: (document: string, unit: Unit) => void;
  handleClickFilterPaid: (document: string, unit: Unit) => void;
  handleClickFilterAll: (document: string, unit: Unit) => void;
  handleClickFilterOrderBy: (
    document: string,
    unit: Unit,
    value?: string
  ) => void;
  handleClickChangeUnit: (document: string, unit: Unit) => void;
  handleClickNavigatePage: (
    document: string,
    unit: Unit,
    page?: string | number
  ) => void;
  handleClickResponsePool: (document: string, unit: Unit) => void;
  handleClickContinueResponsePool: (document: string, unit: Unit) => void;
  handleClickRetryResponsePool: (document: string, unit: Unit) => void;
  handleClickBack: (document: string, unit: Unit) => void;
  documentInvalid: (document: string, message: string) => void;
  viewModalSelectUnit: (document: string) => void;
  handleSelectUnit: (document: string, unit: Unit) => void;
  handleClickContinueSelectUnit: (document: string, unit: Unit) => void;
  responsePool: (document: string, unit: Unit, message: string) => void;
  errorRequestBills: (document: string, unit: Unit) => void;
};

export const useGaEvents = (): UseGaEventsType => {
  const handleClickDocument = (document: string): void => {
    firebase.analytics().logEvent("boletoTelaLogin", {
      document,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        boletoTelaLogin: {
          document,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
        },
      },
    });
  };

  const handleClickCopyBarCode = (
    document: string,
    unit: Unit,
    installment: BillData
  ): void => {
    firebase.analytics().logEvent("copiarCodBarras", {
      document,
      unit,
      installment,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        copiarCodBarras: {
          document,
          unit,
          installment,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
          installment,
        },
      },
    });
  };

  const handleClickDownloadResumeBill = (
    document: string,
    unit: Unit,
    installment: BillData
  ): void => {
    firebase.analytics().logEvent("downloadBoletoResumido", {
      document,
      unit,
      installment,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        downloadBoletoResumido: {
          document,
          unit,
          installment,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
          installment,
        },
      },
    });
  };

  const handleClickDownloadCompleteBill = (
    document: string,
    unit: Unit,
    installment: BillData
  ): void => {
    firebase.analytics().logEvent("downloadBoletoCompleto", {
      document,
      unit,
      installment,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        downloadBoletoCompleto: {
          document,
          unit,
          installment,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
          installment,
        },
      },
    });
  };

  const handleClickFilterOpen = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("boletosEmAberto", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        boletosEmAberto: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickFilterClosed = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("boletosVencidos", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        boletosVencidos: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickFilterPaid = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("boletosPagos", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        boletosPagos: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickFilterAll = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("boletosTodos", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        boletosTodos: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickFilterOrderBy = (
    document: string,
    unit: Unit,
    value?: string
  ): void => {
    firebase.analytics().logEvent("opcaoOrdenacao", {
      document,
      unit,
      value,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        opcaoOrdenacao: {
          document,
          unit,
          value,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
          value,
        },
      },
    });
  };

  const handleClickChangeUnit = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("trocaDeUnidade", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        trocaDeUnidade: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickNavigatePage = (
    document: string,
    unit: Unit,
    page?: string | number
  ): void => {
    firebase.analytics().logEvent("trocaPaginaListagem", {
      document,
      unit,
      page,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        trocaPaginaListagem: {
          document,
          unit,
          page,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
          page,
        },
      },
    });
  };

  const handleClickResponsePool = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("responderPerguntas", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        responderPerguntas: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickContinueResponsePool = (
    document: string,
    unit: Unit
  ): void => {
    firebase.analytics().logEvent("continuarPerguntas", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        continuarPerguntas: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickRetryResponsePool = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("retryPerguntas", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        retryPerguntas: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickBack = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("loginListagemBoletos", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        loginListagemBoletos: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const documentInvalid = (document: string, message: string): void => {
    firebase.analytics().logEvent("cpfInvalido", {
      document,
      message,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        cpfInvalido: {
          document,
          message,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          message,
        },
      },
    });
  };

  const viewModalSelectUnit = (document: string): void => {
    firebase.analytics().logEvent("modalSelecaoUnidade", {
      document,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        modalSelecaoUnidade: {
          document,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
        },
      },
    });
  };

  const handleSelectUnit = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("selecaoUnidade", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        selecaoUnidade: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const handleClickContinueSelectUnit = (
    document: string,
    unit: Unit
  ): void => {
    firebase.analytics().logEvent("continuarSelecaoUnidade", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        continuarSelecaoUnidade: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const responsePool = (
    document: string,
    unit: Unit,
    message: string
  ): void => {
    firebase.analytics().logEvent("retornoRespostas", {
      document,
      unit,
      message,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        retornoRespostas: {
          document,
          unit,
          message,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  const errorRequestBills = (document: string, unit: Unit): void => {
    firebase.analytics().logEvent("erroListagem", {
      document,
      unit,
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        erroListagem: {
          document,
          unit,
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        document: {
          document,
          unit,
        },
      },
    });
  };

  return {
    handleClickDocument,
    handleClickCopyBarCode,
    handleClickDownloadResumeBill,
    handleClickDownloadCompleteBill,
    handleClickFilterOpen,
    handleClickFilterClosed,
    handleClickFilterPaid,
    handleClickFilterAll,
    handleClickFilterOrderBy,
    handleClickChangeUnit,
    handleClickNavigatePage,
    handleClickResponsePool,
    handleClickContinueResponsePool,
    handleClickRetryResponsePool,
    handleClickBack,
    documentInvalid,
    viewModalSelectUnit,
    handleSelectUnit,
    handleClickContinueSelectUnit,
    responsePool,
    errorRequestBills,
  };
};
